module.exports = __webpack_public_path__ + "static/media/7b_website_logo_Gold_jec.d6adde8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/7b_website_logo_Gold_jec.jpg
// module id = 110
// module chunks = 0